module.exports = __webpack_public_path__ + "img/illustration.1bf60904.png";